import { render, staticRenderFns } from "./incomeFromHousePropertyPopUp.vue?vue&type=template&id=d38b98b4&scoped=true"
import script from "./incomeFromHousePropertyPopUp.vue?vue&type=script&lang=js"
export * from "./incomeFromHousePropertyPopUp.vue?vue&type=script&lang=js"
import style0 from "./incomeFromHousePropertyPopUp.vue?vue&type=style&index=0&id=d38b98b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38b98b4",
  null
  
)

export default component.exports